import React from "react";
import useLenis from "@/lib/useLenis";
import Nav from "@/components/sentinel/Nav";
import Hero from "@/components/sentinel/Hero";
import TrustStrip from "@/components/sentinel/TrustStrip";
import Marquee from "@/components/sentinel/Marquee";
import Problem from "@/components/sentinel/Problem";
import Manifesto from "@/components/sentinel/Manifesto";
import CivicNetwork from "@/components/sentinel/CivicNetwork";
import HowItWorks from "@/components/sentinel/HowItWorks";
import Features from "@/components/sentinel/Features";
import Comparison from "@/components/sentinel/Comparison";
import Coverage from "@/components/sentinel/Coverage";
import Rewards from "@/components/sentinel/Rewards";
import Roadmap from "@/components/sentinel/Roadmap";
import Testimonials from "@/components/sentinel/Testimonials";
import Community from "@/components/sentinel/Community";
import Support from "@/components/sentinel/Support";
import Faq from "@/components/sentinel/Faq";
import FinalCTA from "@/components/sentinel/FinalCTA";
import Footer from "@/components/sentinel/Footer";
import ScrollProgress from "@/components/sentinel/ScrollProgress";

export default function Landing() {
    useLenis();
    return (
        <main className="relative">
            <ScrollProgress />
            <Nav />
            <Hero />
            <TrustStrip />
            <Marquee />
            <Problem />
            <Manifesto />
            <CivicNetwork />
            <HowItWorks />
            <Features />
            <Comparison />
            <Coverage />
            <Rewards />
            <Roadmap />
            <Testimonials />
            <Community />
            <Support />
            <Faq />
            <FinalCTA />
            <Footer />
        </main>
    );
}
